import {
  quarterlyRevenueStoreKey,
  AppStateWithQuarterlyRevenueStateData as State,
} from './quarterlyRevenue.types';

const select = (state: State) => state[quarterlyRevenueStoreKey];

export const getLoading = (state: State) => select(state).loading;
export const getSelectedAccount = (state: State) => select(state).accounts;
export const getAccountById = (state: State) => select(state).accountsList;
export const getSortBy = (state: State) => select(state).sortBy;

export const getSortOrder = (state: State) => select(state).sortOrder;

export const getSortQuarterlyRevenueBy = (state: State) =>
  select(state).sortQuarterlyRevenueBy;

export const getQuarterlyRevenueSortOrder = (state: State) =>
  select(state).quarterlyRevenueSortOrder;

export const selectRevenuePageFilters = (state: State) => select(state).filters;
export const getCurrentPage = (state: State) => select(state).currentPage;
export const getlimit = (state: State) => select(state).pageSize;
export const getTotalPages = (state: State) => select(state).totalPages;
export const getForecastDateLocal = (state: State) =>
  select(state).dateFilterValueLocal;
export const getIsUniqueFilterListsDefined = (state: State) =>
  select(state).isUniqueFilterListsDefined;
export const getUniqueFilterLists = (state: State) =>
  select(state).uniqueFilterLists;
